// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-student{width:550px}.state-select-separator{font-weight:bold;padding:14px 14px 10px}`, "",{"version":3,"sources":["webpack://./src/modals/EditSchool/style.scss"],"names":[],"mappings":"AACA,cACE,WAAA,CAGF,wBACI,gBAAA,CACA,sBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
